import { ThemeProvider, EmotionCacheProvider } from '@ori-ui/mui';
import { parseClientAppConfig } from '@ori/client-app-config';
import { ApplicationInsights, ErrorBoundary, getClientApplicationInsightsConfig, LoggerProvider } from '@ori/logger';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { APP_NAME, EMOTION_CACHE_KEY } from './constants';
import { logDebug, mainLogger } from './logger';

/**
 * React app renderer that is used when app is used as a standalone app
 */
import { jsx as _jsx } from "react/jsx-runtime";
export async function render(rootElement) {
  const {
    config = ''
  } = rootElement.dataset;
  const configuration = parseClientAppConfig(config, ['currentLanguage', 'staticApiUrl', 'tenant']);
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_REQUESTLY === '1') {
    logDebug('USING REQUESTLY');
  }

  // Initialize Application Insights in production
  if (process.env.NODE_ENV === 'production') {
    ApplicationInsights.initialize(getClientApplicationInsightsConfig());
  }
  createRoot(rootElement).render(/*#__PURE__*/_jsx(LoggerProvider, {
    logger: mainLogger,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      areaName: `${APP_NAME}-boundary`,
      children: /*#__PURE__*/_jsx(EmotionCacheProvider, {
        cacheKey: EMOTION_CACHE_KEY,
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          children: /*#__PURE__*/_jsx(App, {
            ...configuration
          })
        })
      })
    })
  }));
}